/**
 * Initialises Helper Wizard
 *
 * @param {*} helperWizard
 * @returns
 */

initWizard();

function initWizard() {
  let helperWizard = document.querySelector('#hw--component-wrapper');

  if (!helperWizard) {
    console.log('Helper wizard not found');

    return;
  }

  let introSection = helperWizard.querySelector('.intro-section');
  let startBtn = introSection.querySelector('.hw-button');
  let quizSection = helperWizard.querySelector('.quiz-section');
  let nextBtns = quizSection.querySelectorAll('.hw-button:not(.back-button)');
  let backBtns = quizSection.querySelectorAll('.back-button');
  let fieldsets = quizSection.querySelectorAll('fieldset');
  let resultsSection = helperWizard.querySelector('.results-section');
  let fieldOptions = helperWizard.querySelectorAll('input[type="radio"]');
  let totalSteps = helperWizard.querySelector('.fieldset-total');
  let currentStep = helperWizard.querySelector('.current-fieldset');
  let progressBar = helperWizard.querySelector('.progress-bar');

  if (
    (!introSection || !quizSection || !resultsSection || startBtn || totalSteps || currentStep || progressBar) &&
    (nextBtns.length < 1 || fieldOptions.length < 1 || fieldsets.length < 1)
  ) {
    console.log('Please include all required HTML classes. Check initWizard() for all required classes in src.');

    return;
  }

  let currentStepValue = 1;
  let totalStepsValue = fieldsets.length;

  currentStep.textContent = currentStepValue;
  totalSteps.textContent = totalStepsValue;

  let stepProgress = ((currentStepValue / totalStepsValue) * 100);

  startBtn.addEventListener('click', function () {
    introSection.classList.add('hw-hidden');
    quizSection.classList.remove('hw-hidden');
  });

  progressBar.style.setProperty('--progress', stepProgress + "%");

  nextBtns.forEach(nextBtn => {
    nextBtn.addEventListener('click', function () {
      let currentFieldset = this.parentElement.parentElement;
      let fieldOptionsInSection = currentFieldset.querySelectorAll('input[type="radio"]');
      let isAtLeastOneOptionChecked = false;

      fieldOptionsInSection.forEach(fieldOption => {
        if (fieldOption.checked) {
          isAtLeastOneOptionChecked = true;

          if (fieldOption.dataset.optionToDisable) {
            //helperWizard.querySelector('[data-conditional-option="' + fieldOption.dataset.optionToDisable + '"]').classList.add('hw-hidden');
            helperWizard.querySelectorAll('[data-conditional-option="' + fieldOption.dataset.optionToDisable + '"]').forEach(function(conditionalOption){
              conditionalOption.classList.add('hw-hidden');
            });
          }

          if (fieldOption.dataset.conditionalFieldsetName) {
            let selectedFieldsetName = fieldOption.dataset.conditionalFieldsetName;
            let conditionalFieldset = helperWizard.querySelector('[data-conditional-fieldset]');

            if (conditionalFieldset) {
              let conditionalFieldsetData = conditionalFieldset.dataset.conditionalFieldset;
              let selectedFieldsetOption = JSON.parse(conditionalFieldsetData)[selectedFieldsetName];

              conditionalFieldset.querySelector('h2').innerHTML = selectedFieldsetOption.title;

              selectedFieldsetOption.options.forEach(
                function (option) {
                  let optionsValues = option.split('|');

                  conditionalFieldset.querySelector('ul').insertAdjacentHTML(
                    'beforeend',
                    `
                    <li class="hw-relative">
                        <input
                        value="${optionsValues[0]}"
                        type="radio"
                        name="product_conditional_option"
                        data-points="${optionsValues[1]}"
                        >

                        <label>
                            ${optionsValues[0]}
                        </label>
                    </li>
                    `
                  );
                }
              );
            }
          }
        }
      });

      if (this.classList.contains('get-results')) {
        if (this.previousElementSibling.value === '') {
          this.classList.add('validation-error-email');

          return;
        }
      }

      if (!isAtLeastOneOptionChecked && !this.classList.contains('get-results')) {
        this.classList.add('validation-error');

        return;
      }

      currentFieldset.classList.add('hw-hidden');
      currentFieldset.nextElementSibling.classList.remove('hw-hidden');
      currentStepValue++;
      currentStep.textContent = currentStepValue;
      stepProgress = ((currentStepValue / totalStepsValue) * 100);
      progressBar.style.setProperty('--progress', stepProgress + "%");

      if (stepProgress === 100) {
        let allCheckedOptions = Array.from(helperWizard.querySelectorAll('ul li input[type="radio"]:checked'));

        let totalPoints = allCheckedOptions.map(function(checkedField){
          return parseInt(checkedField.dataset.points);
        });

        let totalScore = totalPoints.reduce(function (x, y) {
          return x + y;
        }, 0);

        let productsToDisplay = null;

        if (pointsResultsMatrix[totalScore] != undefined) {
          productsToDisplay = pointsResultsMatrix[totalScore];
        } else {
          let findClosestNumber = Object.keys(pointsResultsMatrix).reduce(function(prev, curr) {
            return (Math.abs(curr - totalScore) < Math.abs(prev - totalScore) ? curr : prev);
          });

          productsToDisplay = pointsResultsMatrix[findClosestNumber];
        }

        helperWizard.querySelector('#hw-title').innerHTML       = productsToDisplay['title'];
        helperWizard.querySelector('#hw-description').innerHTML = productsToDisplay['body'];

        let listHTML = '';
        productsToDisplay['list'].forEach(function(listPoint){
          let listComponents = listPoint.split('|');
          let listIcon       = listComponents[0]
          let listText       = listComponents[1];

          listHTML += `<li class="${listIcon}-icon">${listText}</li>`;
        });

        helperWizard.querySelector('#hw-list').innerHTML = listHTML;

        if (Array.isArray(productsToDisplay['ids'])) {
          productsToDisplay['ids'].forEach(function(productToDisplay){
            helperWizard.querySelector('[data-hw-product-id="' + productToDisplay + '"]').style.display = 'block';
          });
        } else {
          helperWizard.querySelector('[data-hw-product-id="' + productsToDisplay['ids'] + '"]').style.display = 'block';
          helperWizard.querySelector('[data-hw-product-id="' + productsToDisplay['ids'] + '"]').style.margin  = '0 auto';
        }

        let quizKlaviyoForm = helperWizard.querySelector('form.klaviyo-form');

        /**
         * Holy actual living mother of Joseph, what a pain in the bottom this was.
         * These comments are public to profanity shall not be tolerated.
         *
         * These embedded form fields need actual clicks to register and update its values
         * which got me peeved several times throughout this task.
         *
         * This is why there's a fakeInput event and why I'm clicking the labels of the radio buttons instead of just assigning the values
         *
         * And don't get me started on submitting the actual form via JS. What a slight hindrence that was.
         *
         * It cheekily took 5 years off my life span. I wish to never do this type of thing again.
         *
         * TL;DR: I couldn't use the Klaviyo API as storing a private key client side (via JS) is baaaad.
         * So I've added a hidden embed form which I'm populating then submitting via JS. What a weird workaround, eh?
         */
        if (quizKlaviyoForm) {
          var fakeInput = new MouseEvent('input', {
            bubbles: true,
            cancelable: true
          });

          let selectedKlaviyoFormAnswers = allCheckedOptions.map(function(checkedField){
            return checkedField.name + '|' + checkedField.value;
          });

          let dataLayerPayload = {
            'hairQuizQuestions' : {},
            'event' : 'hair_quiz_submitted'
          }

          selectedKlaviyoFormAnswers.forEach(function(selectedKlaviyoFormAnswer){
            let splitStr   = selectedKlaviyoFormAnswer.split('|');
            let inputName  = splitStr[0];
            let inputValue = splitStr[1];

            let selectedQuizKlaviyoFormInput = quizKlaviyoForm.querySelector('input[aria-label="' + inputValue + '"]');

            selectedQuizKlaviyoFormInput.nextElementSibling.click();

            dataLayerPayload.hairQuizQuestions[inputName] = inputValue;
          });

          let quizEmailField             = helperWizard.querySelector('input[name="email"]');
          let klaviyoRecommendationField = quizKlaviyoForm.querySelector('input[id^="quiz__recommendation"]');
          let klaviyoEmailField          = quizKlaviyoForm.querySelector('input[name="email"]');

          klaviyoRecommendationField.value = productsToDisplay['title'].split(': ')[1];
          klaviyoEmailField.value          = quizEmailField.value;

          klaviyoRecommendationField.dispatchEvent(fakeInput);
          klaviyoEmailField.dispatchEvent(fakeInput);

          dataLayerPayload.hairQuizQuestions['recommendation'] = productsToDisplay['title'].split(': ')[1];

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(dataLayerPayload);

          if (klaviyoEmailField.value !== '' && klaviyoRecommendationField.value !== '') {
            /**
             * Dunno. If I don't use setTimeout it doesn't store the values correctly for some reason.
             * And I'm referencing from the document again for a fresh grab, just incase.
             */
            setTimeout(() => {
              document.querySelector('form.klaviyo-form button[type="button"]').click();
            }, 500);
          }
        }
      }
    });
  });
  backBtns.forEach(backBtn => {
    backBtn.addEventListener('click', function () {
      let currentFieldset = this.parentElement.parentElement;
  
      if (currentFieldset.previousElementSibling.tagName === 'FIELDSET') {
        let validationErrorElements = currentFieldset.previousElementSibling.querySelectorAll('.validation-error');
          validationErrorElements.forEach(element => {
            element.classList.remove('validation-error');
          });
        currentFieldset.classList.add('hw-hidden');
        currentFieldset.previousElementSibling.classList.remove('hw-hidden');
        currentStepValue--;
        currentStep.textContent = currentStepValue;
        stepProgress = ((currentStepValue / totalStepsValue) * 100);
        progressBar.style.setProperty('--progress', stepProgress + "%");
      } else {
        introSection.classList.remove('hw-hidden');
        quizSection.classList.add('hw-hidden');
      }
    });
  });
}
